import api from "./index";

export async function createMatch(body) {
  return api.post("/matches", body);
}

export async function sendMove(matchID, body) {
  return api.put(`/matches/${matchID}/move`, body);
}

export async function getMatches(params) {
  return api.get(`/matches`, { params });
}

export async function extraChance(matchID) {
  return api.get(`/matches/${matchID}/extra-chance`);
}

export async function revealWord(matchID) {
  return api.get(`/matches/${matchID}/reveal`);
}

export async function postMatchHint(matchID, body) {
  return api.post(`/matches/${matchID}/hint`, body);
}
